(() => {
  'use strict';
  if (customElements.get('rc-dealers')) return;

  class RcDealers extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.dialog?.close?.();
      this.events?.abort();
    }

    init() {
      this.events?.abort();
      this.events = new AbortController();
      const signal = this.events.signal;
      // Empty out-of-range pagination can omit all Liquid page URLs. The browser
      // still has the complete query, including collection filters and preview.
      this.querySelectorAll('[data-dealer-first-page]').forEach(link => {
        const url = new URL(window.location.href);
        url.searchParams.set(link.dataset.dealerFirstPage, '1');
        url.hash = new URL(link.href).hash;
        link.href = url.href;
      });
      this.dialog = this.querySelector('dialog');
      this.select = this.querySelector('[data-dealer-region]');
      this.buttons = [...this.querySelectorAll('[data-dealer-filter]')];
      if (!this.select && !this.buttons.length) return;
      this.cards = [...this.querySelectorAll('[data-dealer-card]')];
      this.groups = [...this.querySelectorAll('[data-dealer-group]')];
      const results = this.querySelector('[data-dealer-results]');
      // One server-rendered directory, usable without JS. Move it into the
      // dialog only after modal support is established.
      if (this.dialog && typeof this.dialog.showModal === 'function') {
        this.dialog.append(this.querySelector('[data-dealer-directory]'));
        this.querySelector('[data-dealer-tiles]').hidden = false;
        this.addEventListener('click', event => {
          const opener = event.target.closest('[data-dealer-open]');
          if (!opener || !this.contains(opener)) return;
          this.opener = opener;
          this.select.value = opener.dataset.dealerOpen;
          this.filter();
          this.dialog.showModal();
          opener.setAttribute('aria-expanded', 'true');
          this.select.focus();
        }, {signal});
        this.querySelector('[data-dealer-close]').addEventListener('click', () => this.dialog.close(), {signal});
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right ||
              event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        }, {signal});
        this.dialog.addEventListener('close', () => {
          if (this.opener) {
            this.opener.setAttribute('aria-expanded', 'false');
            if (this.opener.isConnected) this.opener.focus();
          }
        }, {signal});
      }
      if (this.select) {
        this.select.disabled = false;
        this.select.addEventListener('change', () => this.filter(), {signal});
        results.setAttribute('tabindex', '0');
      }
      this.buttons.forEach(button => {
        button.addEventListener('click', () => this.filter(button.dataset.dealerFilter), {signal});
      });
      this.filter();
      const filters = this.querySelector('[data-dealer-filters]');
      if (filters) filters.hidden = false;
    }

    filter(region = this.select?.value || this.region || 'all') {
      this.region = region;
      let count = 0;
      this.cards.forEach(card => {
        card.hidden = region !== 'all' && card.dataset.region !== region;
        if (!card.hidden) count++;
      });
      this.groups.forEach(group => { group.hidden = region !== 'all' && group.dataset.region !== region; });
      this.buttons.forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.dealerFilter === region));
      });
      const label = count === 1 ? this.dataset.countOne : this.dataset.countOther;
      this.querySelector('[data-dealer-count]').textContent = count + ' ' + label;
      this.querySelector('[data-dealer-results]').scrollTop = 0;
    }
  }
  customElements.define('rc-dealers', RcDealers);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('rc-dealers').forEach(element => element.init());
  });
})();
